import { useQuery } from '@tanstack/react-query';

import { type ReproduceSearchParams, getSearchReproduction } from '~/services/ReproduceSearchService';

import { reproduceSearchQueryKeys } from './reproduceSearchQueryKeys';

export function useReproduceSearch(params: ReproduceSearchParams | null) {
  return useQuery({
    queryKey: reproduceSearchQueryKeys.result(params ?? { startDate: '', endDate: '', searchId: '' }),
    queryFn: async ({ signal }) => {
      return await getSearchReproduction(params!, { signal });
    },
    enabled: params !== null,
    retry: false,
  });
}
